import { Directive, Host, Input, TemplateRef } from '@angular/core';
import { KalOptionComponent } from '@kalidea/kaligraphi';

@Directive({
    selector: '[appSharedSearchbarParameters]',
    standalone: false
})
export class SharedSearchbarParametersDirective {

    @Input() appSharedSearchbarParameters = null;

    @Input() searchbarTemplate: TemplateRef<any> = null;

    constructor(@Host() public kalOptionComponent: KalOptionComponent) {
    }

}
